<ion-menu contentId="root-component"
          menuId="property-menu">
    <ion-header class="menu-header ion-no-border">
        <ion-toolbar color="primary">
            <ion-buttons slot="start">
                <ion-menu-toggle menu="property-menu">
                    <ion-button (click)="back()">
                        <ion-icon class="header-back__icon--desktop"
                                  mode="ios"
                                  name="chevron-back"></ion-icon>
                        <ion-text class=""
                                  *ngIf="true">Previous page</ion-text>
                    </ion-button>
                </ion-menu-toggle>
            </ion-buttons>

            <ion-buttons slot="end">
                <ion-menu-button menu="property-menu"></ion-menu-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
    <ion-content color="primary">
        <!-- Regular Side Menu -->
        <ion-list class="ion-no-padding" *ngIf="!orgService.isPI">
            <!-- Property Details -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          [routerLink]="[currentRoute + '/details']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Property Details</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Offer Calculator -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="orgService.canActivate('property-offer-calculator') && !isSAProperty && !auth.isVendor && !auth.isTC"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/offer-calculator']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Offer Calculator</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Rehab Calculator -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="orgService.canActivate('property-rehab-calculator') && !isSAProperty && !auth.isVendor && !auth.isTC"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/rehab-calculator']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Rehab Calculator</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- AA Flip -->
<!--            <ion-menu-toggle menu="property-menu">-->
<!--                <ion-item class="menu__item"-->
<!--                          *ngIf="orgService.canActivate('property-aa-flip') && !isSAProperty && !auth.isVendor && !auth.isTC"-->
<!--                          [disabled]="!state.property.id"-->
<!--                          [routerLink]="[currentRoute + '/aa-flip']"-->
<!--                          replaceUrl="true"-->
<!--                          queryParamsHandling="merge"-->
<!--                          routerLinkActive="menu__item&#45;&#45;active"-->
<!--                          lines="none">-->
<!--                    <ion-label>AA Flip</ion-label>-->
<!--                </ion-item>-->
<!--            </ion-menu-toggle>-->

            <!-- AA Rental -->
<!--            <ion-menu-toggle menu="property-menu">-->
<!--                <ion-item class="menu__item"-->
<!--                          *ngIf="orgService.canActivate('property-aa-rental') && !isSAProperty && !auth.isVendor && !auth.isTC"-->
<!--                          [disabled]="!state.property.id"-->
<!--                          [routerLink]="[currentRoute + '/aa-rental']"-->
<!--                          replaceUrl="true"-->
<!--                          queryParamsHandling="merge"-->
<!--                          routerLinkActive="menu__item&#45;&#45;active"-->
<!--                          lines="none">-->
<!--                    <ion-label>AA Rental</ion-label>-->
<!--                </ion-item>-->
<!--            </ion-menu-toggle>-->

            <!-- Flip Analysis -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="orgService.canActivate('property-flip-analysis') && !auth.isVendor && !auth.isTC"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/flip-analysis']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Flip Analysis</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Rental Analysis -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="orgService.canActivate('property-rental-analysis') && !auth.isVendor && !auth.isTC"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/rental-analysis']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Rental Analysis</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Rehab Schedule -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="auth.isVendor"
                          [routerLink]="[currentRoute + '/rehab-schedule']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Rehab Schedule</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Accounting -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="auth.isVendor"
                          [routerLink]="[currentRoute + '/accounting']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Accounting</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Attachments -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="orgService.canActivate('property-attachments') && !isSAProperty"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/attachments']"
                          replaceUrl="true"
                          [queryParams]="{ segment: '' }"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Attachments</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Marketing -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="orgService.canActivate('property-marketing') && !auth.isVendor"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/marketing']"
                          replaceUrl="true"
                          [queryParams]="{ segment: '' }"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Marketing</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Contracts -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="orgService.canActivate('property-contracts')"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/contracts']"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Contracts</ion-label>
                </ion-item>
            </ion-menu-toggle>
        </ion-list>

        <!-- --------------------------------------------------------------------------------------------------------------- -->
        <!-- PI Side Menu -->
        <!-- --------------------------------------------------------------------------------------------------------------- -->
        <ion-list class="ion-no-padding" *ngIf="orgService.isPI">
            <!-- Property Details -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          [routerLink]="[currentRoute + '/details']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Property Details</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Offer Calculator -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="!auth.isPM && !auth.isVendor"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/offer-calculator']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Offer Calculator</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Rehab Calculator -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="!auth.isPM && !auth.isVendor"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/rehab-calculator']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Rehab Calculator</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Flip Analysis -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="!auth.isPM && !auth.isVendor"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/flip-analysis']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Flip Analysis</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Rental Analysis -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="!auth.isPM && !auth.isVendor"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/rental-analysis']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Rental Analysis</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Vendors -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="!auth.isVendor"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/vendors']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Vendors</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!--    &lt;!&ndash; Rehab Schedule &ndash;&gt;-->
            <!--    <ion-item class="menu__item"-->
            <!--              [disabled]="!state.property.id"-->
            <!--              [routerLink]="['rehab-schedule']"-->
            <!--              replaceUrl="true"-->
            <!--              queryParamsHandling="merge"-->
            <!--              routerLinkActive="menu__item&#45;&#45;active"-->
            <!--              lines="none">-->
            <!--        <ion-label>Rehab Schedule</ion-label>-->
            <!--    </ion-item>-->

            <!--    &lt;!&ndash; Accounting &ndash;&gt;-->
            <!--    <ion-item class="menu__item"-->
            <!--              [disabled]="!state.property.id"-->
            <!--              [routerLink]="['accounting']"-->
            <!--              replaceUrl="true"-->
            <!--              queryParamsHandling="merge"-->
            <!--              routerLinkActive="menu__item&#45;&#45;active"-->
            <!--              lines="none">-->
            <!--        <ion-label>Accounting</ion-label>-->
            <!--    </ion-item>-->

            <!-- Flyer -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          *ngIf="!auth.isPM && !auth.isVendor"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/marketing']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Flyer</ion-label>
                </ion-item>
            </ion-menu-toggle>

            <!-- Attachments -->
            <ion-menu-toggle menu="property-menu">
                <ion-item class="menu__item"
                          [disabled]="!state.property.id"
                          [routerLink]="[currentRoute + '/attachments']"
                          replaceUrl="true"
                          queryParamsHandling="merge"
                          routerLinkActive="menu__item--active"
                          lines="none">
                    <ion-label>Attachments</ion-label>
                </ion-item>
            </ion-menu-toggle>
        </ion-list>
    </ion-content>
</ion-menu>
